import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'app-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent {

    @Input() public icon: string;
    @Input() public label: string;
    @Output() public clicked = new EventEmitter<any>();

    @ViewChild('contextMenu', {static: false}) private readonly contextMenu: TemplateRef<any>;

    private contextMenuSub: Subscription;

    protected cardContextOverlayRef: OverlayRef;

    constructor(private readonly overlay: Overlay, private readonly theViewContainerRef: ViewContainerRef) {}

    public openCardContext<T>(event: { event: MouseEvent; data: T }) {
        // Close any other context menus
        this.closeCardContext();

        // Create a new position strategy (where we draw the card)
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo({x: event.event.x, y: event.event.y})
            .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'bottom'
                }
            ]);

        // Create an overlay (close the overlay if the user scrolls)
        this.cardContextOverlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        // Attach the overlay to our view template and pass in the card as data
        this.cardContextOverlayRef.attach(new TemplatePortal(this.contextMenu, this.theViewContainerRef, {$implicit: event.data}));

        // Close the context menu if someone clicks outside of it
        this.contextMenuSub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(e => {
                    const clickTarget = e.target as HTMLElement;
                    return !!this.cardContextOverlayRef && !this.cardContextOverlayRef.overlayElement.contains(clickTarget);
                }),
                take(1)
            ).subscribe(() => this.closeCardContext());
    }

    public closeCardContext() {
        if (this.contextMenuSub) {
            this.contextMenuSub.unsubscribe();
        }
        if (this.cardContextOverlayRef) {
            this.cardContextOverlayRef.dispose();
            this.cardContextOverlayRef = null;
        }
    }

}
